import React from "react";
import bannerImg from "../../assets/images/ai.png";
import "../../styles/SalesFunnel.css";

import { Link } from "react-router-dom";

function AIbanner() {
  return (
    <div>
      <section className="webbanner">
        <div className="webbanner-content">
          <h1>AI Automation Services for Smarter Business Growth</h1>
          <p>
            In these days’s fast-evolving digital international, organizations
            are constantly seeking out smarter methods to improve performance,
            lessen costs, and scale operations. This is where <b>ai automation services</b> come into play. By leveraging advanced technologies,
            businesses can automate repetitive responsibilities, decorate
            selection-making.
          </p>
          <div className="webbanner-cta">
            <a href="./Contact" className="webbanner-btn primary">
              Get Free Consultation →
            </a>
          </div>
        </div>
        <div className="webbanner-image">
          <img src={bannerImg} alt="Web Development Solutions" />
        </div>
      </section>
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <span> AI Automation Services</span>
      </div>
    </div>
  );
}

export default AIbanner;
